export default {"src":"/_next/static/media/fade-stagger-circles.906ebd50.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};